import { useQuery } from '@apollo/client'
import { GET_BUSINESS_SITES_SUGGESTIONS } from 'features/BusinessSites/queries-legacy'
import { GTBusinessSiteSuggestion, GTBusinessSiteSuggestionsResponse } from 'gql/types.generated'

interface IUseBusinessSiteAutocompleteOptions {
  skip?: boolean
}

export const useBusinessSiteAutocomplete = (
  businessSiteId: string,
  { skip }: IUseBusinessSiteAutocompleteOptions = {}
): GTBusinessSiteSuggestion | null => {
  const { data } = useQuery<{ businessSiteSuggestions: GTBusinessSiteSuggestionsResponse }>(
    GET_BUSINESS_SITES_SUGGESTIONS,
    {
      skip,
      variables: {
        input: {
          id: businessSiteId
        }
      }
    }
  )

  return data?.businessSiteSuggestions?.items.at(0) || null
}
